module.exports = __webpack_public_path__ + "static/media/Celebrative.4a787700.svg";